// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toolbar":"toolbar-j5aUh5hG","partTitle":"partTitle-1kDod_H4","partMore":"partMore-3T881s7f","videoList":"videoList-2x0ZoJgx"};